"use client";
import Link from "next/link";
import { MdArrowForwardIos } from "react-icons/md";
import { Button } from "@/components/shadcn/Button";

export default function NotFound() {
  return (
    <div className="px-8">
      <h1 className="pb-4 scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
        Oops!
      </h1>
      <h2 className="pb-4 text-deep-purple-300 scroll-m-20 pb-2 text-2xl font-semibold tracking-tight first:mt-0">
        Your content is in another page
      </h2>
      <Link href="/">
        <Button className="p-2 flex items-center gap-2" color="white">
          Go Home
          <MdArrowForwardIos />
        </Button>
      </Link>
    </div>
  );
}
